//商品接口相关的函数
import request from "../utils/request"

//学习痕迹
export let getcountevaluationcriterion = (params) => request.get('/study/evaluation/criterion/getcountevaluationcriterion', { params })
export let queryTakingOrHavingTakenCourses = (params) => request.get('/study/course/info/queryTakingOrHavingTakenCourses', { params })
export let getHomeworkLearningTrace = (params) => request.get('/study/homework/info/getHomeworkLearningTrace', { params })
export let getPresentAndPastLessons = (params) => request.get('/study/course/info/getPresentAndPastLessons', { params })

export let getEvaluationFavorite = (params) => request.get('/study/evaluation/criterion/getEvaluationFavorite', { params })
export let getResourceBrowsing = (params) => request.get('/study/evaluation/criterion/getEvaluationBrowsing', { params })
export let getEvaluationAppraised = (params) => request.get('/study/evaluation/criterion/getEvaluationAppraised', { params })
export let getResourceViewtime = (params) => request.get('/study/evaluation/criterion/getResourceViewtime', { params })
export let getidandname = (params) => request.get('/controller/evaluation/class/getidandname', { params })
export let getEvaluationPraise = (params) => request.get('/study/evaluation/criterion/getEvaluationPraise', { params })




//修改用户头像
// export let updatephotourl = (params) => request.post('/controller/user/userinfo/updatephotourl', params)
